'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _glamor = require('glamor');

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _reduxForm = require('redux-form');

var _polyfluid = require('@quixeltools/quixel-ui-library/dist/utils/polyfluid');

var _ChoiceSection = require('@quixeltools/quixel-ui-library/dist/components/megascans/subscriptions/ChoiceSection');

var _ChoiceSection2 = _interopRequireDefault(_ChoiceSection);

var _ChoiceLicence = require('@quixeltools/quixel-ui-library/dist/components/megascans/subscriptions/ChoiceLicence');

var _ChoiceLicence2 = _interopRequireDefault(_ChoiceLicence);

var _ChoiceDetails = require('@quixeltools/quixel-ui-library/dist/components/megascans/subscriptions/ChoiceDetails');

var _ChoiceDetails2 = _interopRequireDefault(_ChoiceDetails);

var _Hr = require('@quixeltools/quixel-ui-library/dist/components/common/website/Hr');

var _Hr2 = _interopRequireDefault(_Hr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPlan = function getPlan(plan) {
  return 'Max Resolution ' + plan;
};
var titleByKey = _ramda2.default.cond([[_ramda2.default.either(_ramda2.default.equals('resolution'), _ramda2.default.equals('accessResolution')), _ramda2.default.compose(getPlan, _ramda2.default.nthArg(1))], [_ramda2.default.equals('higherRevenueAlternate'), _ramda2.default.always('Your Revenue Bracket:')], [_ramda2.default.equals('license'), _ramda2.default.always('License Terms')], [_ramda2.default.equals('seats'), _ramda2.default.always('Choose Number of Seats:')], [_ramda2.default.equals('points'), _ramda2.default.always('Points / Year')], [_ramda2.default.equals('billingCycle'), _ramda2.default.always('License Period')], [_ramda2.default.equals('billing'), _ramda2.default.compose(_ramda2.default.cond([[_ramda2.default.equals('freelancer'), _ramda2.default.always('Payment Schedule')], [_ramda2.default.equals('indie'), _ramda2.default.always('Payment Schedule')], [_ramda2.default.equals('pro'), _ramda2.default.always('Payment Schedule')]]), _ramda2.default.nthArg(2))]]);

var getPriceString = function getPriceString(price) {
  return '$' + price + ' per seat/per month';
};

var footnoteByKey = _ramda2.default.cond([[_ramda2.default.either(_ramda2.default.equals('resolution'), _ramda2.default.equals('accessResolution')), _ramda2.default.cond([[_ramda2.default.compose(_ramda2.default.equals('freelancer'), _ramda2.default.nthArg(1)), function (_, __, totalPoints) {
  return '* Points can be used to buy and download assets from the Megascans library. 3D models cost 4 points each, surfaces are 2 points, and scans of any other type cost 1 point each. That\u2019s ' + Math.floor(totalPoints / 2) + ' surfaces, ' + Math.floor(totalPoints / 4) + ' 3D models, or ' + Math.floor(totalPoints / 1) + ' scans of any other type.\n        <br>* Points are refilled at each billing cycle and carry over if not used.\n        <br>* 8K is available for most 3D assets and all surfaces in 2x2 meters and above.';
}], [_ramda2.default.compose(_ramda2.default.equals('archviz'), _ramda2.default.nthArg(1)), function (_, __, totalPoints) {
  return '* Points can be used to buy and download assets from the Megascans library. 3D models cost 4 points each, surfaces are 2 points, and scans of any other type cost 1 point each. That\u2019s ' + Math.floor(totalPoints / 2) + ' surfaces, ' + Math.floor(totalPoints / 4) + ' 3D models, or ' + Math.floor(totalPoints / 1) + ' scans of any other type.\n\n        <br>* Points are refilled at each billing cycle and carry over if not used.\n        <br>* 8K is available for most 3D assets and all surfaces in 2x2 meters and above.';
}], [_ramda2.default.compose(_ramda2.default.equals('indie'), _ramda2.default.nthArg(1)), _ramda2.default.always('* 8K is available for most 3D assets and all surfaces in 2x2 meters and above.')], [_ramda2.default.compose(_ramda2.default.equals('educational'), _ramda2.default.nthArg(1)), _ramda2.default.always('* The license term should match the duration of your class or course.\n        <br>* Your license is renewable after your license period expires.')]])], [_ramda2.default.equals('billingCycle'), _ramda2.default.always('* The license term should match the duration of your class, or course. <br>* Your license is renewable after your license period expires.')], [_ramda2.default.either(_ramda2.default.equals('billing'), _ramda2.default.equals('points')), _ramda2.default.cond([[_ramda2.default.compose(_ramda2.default.equals('freelancer'), _ramda2.default.nthArg(1)), function (_, __, totalPoints) {
  return '\n* Points can be used to buy and download assets from the Megascans library. 3D models cost 4 points each, surfaces are 2 points, and scans of any other type cost 1 point each. That\u2019s ' + Math.floor(totalPoints / 2) + ' surfaces, ' + Math.floor(totalPoints / 4) + ' 3D models, or ' + Math.floor(totalPoints / 1) + ' scans of any other type.\n<br>\n* Points are refilled at each billing cycle and carry over if not used. \n<br>\n* 8K is available for most 3D assets and all surfaces in 2x2 meters and above.\n        ';
}], [_ramda2.default.compose(_ramda2.default.equals('indie'), _ramda2.default.nthArg(1)), function (_, __, totalPoints) {
  return '\n* Points can be used to buy and download assets from the Megascans library. 3D models cost 4 points each, surfaces are 2 points, and scans of any other type cost 1 point each. That\u2019s ' + Math.floor(totalPoints / 2) + ' surfaces, ' + Math.floor(totalPoints / 4) + ' 3D models, or ' + Math.floor(totalPoints / 1) + ' scans of any other type.\n<br>\n* Points are refilled at each billing cycle and carry over if not used. \n<br>\n* 8K is available for most 3D assets and all surfaces in 2x2 meters and above.\n\n        ';
}], [_ramda2.default.compose(_ramda2.default.equals('pro'), _ramda2.default.nthArg(1)), function (_, __, totalPoints) {
  return '\n* Points can be used to buy and download assets from the Megascans library. 3D models cost 4 points each, surfaces are 2 points, and scans of any other type cost 1 point each. That\u2019s ' + Math.floor(totalPoints / 2) + ' surfaces, ' + Math.floor(totalPoints / 4) + ' 3D models, or ' + Math.floor(totalPoints / 1) + ' scans of any other type.\n            <br>\n* Points are refilled at each billing cycle and carry over if not used. \n<br>\n* 8K is available for most 3D assets and all surfaces in 2x2 meters and above.\n\n        ';
}]])], [_ramda2.default.equals('higherRevenueAlternate'), _ramda2.default.always('Please select the bracket that matches your business revenue the closest.')], [_ramda2.default.equals('license'), _ramda2.default.compose(_ramda2.default.cond([[_ramda2.default.equals('freelancer'), _ramda2.default.always('* This plan allows for single seat use by self-employed indies, freelancers and enthusiasts.\n        </br></br>* You are eligible for this plan only when you have less than $100,000 USD annual revenue or funds raised. If you exceed this amount you must contact Quixel for a plan upgrade. Quixel reserves the right to assess your most recent annual business report to verify income claims.\n        </br></br>* Sharing your account information, assets, or tools with others is prohibited.\n        ')], [_ramda2.default.equals('archviz'), _ramda2.default.always('* You are eligible for this plan only when your business is primarily specialized in architectural visualization.\n        </br></br>* You are eligible for this plan only when you have 20 or fewer registered employees or contractors employed by your business.\n        </br></br>* You are granted 1-year total access to Megascans, Bridge and Mixer with unlimited seats. During 1 year, you can create content using Megascans, Bridge and Mixer for any number of concurrent projects. When the license expires, you can still ship your project(s) at any time without any need to relicense, just that you cannot create additional content with Megascans, Bridge and Mixer. You may create additional content using Megascans, Bridge and Mixer for any current or new project(s) as soon as you relicense, and you can use all your previously downloaded Megascans assets without having to pay an extra cost for said assets.\n        </br></br>* If you do not need additional points but wish to continue using Megascans, Bridge, Mixer and all previously downloaded Megascans assets for any commercial project(s), you can purchase a discounted renewal license for another 1-year term. The renewal license will also enable you to spend any unused points from the previous term.\n        </br></br>* Sharing your account information, assets, or tools with others outside your business is prohibited.\n        ')], [_ramda2.default.equals('indie'), _ramda2.default.always('* This plan allows for unlimited members of your business, who are registered employees or who are contractors employed by your business.\n          </br></br>* You are eligible for this plan only when you have less than $2,000,000 USD annual revenue or funds raised, and you are not affiliated with or funded by a publisher owned studio. If you exceed this amount you must contact Quixel for a plan upgrade. Quixel reserves the right to assess your most recent annual business report to verify income claims.\n          </br></br>* Sharing your account information, assets, or tools with others outside your business is prohibited.\n        ')], [_ramda2.default.equals('pro'), _ramda2.default.always('* This plan allows for unlimited members of your business, who are registered employees or who are contractors employed by your business.\n          </br></br>* You are eligible for this plan only when you have less than $20,000,000 USD annual revenue or funds raised, and you are not affiliated with or funded by a publisher owned studio. If you exceed this amount you must contact Quixel for a plan upgrade. Quixel reserves the right to assess your most recent annual business report to verify income claims.\n          </br></br>* Sharing your account information, assets, or tools with others outside your business is prohibited.\n        ')], [_ramda2.default.equals('studio'), _ramda2.default.always('* This license is valid for up to 25 users.')], [_ramda2.default.equals('educational'), _ramda2.default.always('*  Services provided by Quixel under this license are for educational purposes and non-commercial use only.</br></br>\n        * The Quixel XL pack for education contains thousands of assets that are intended to be distributed in educational environments on a shared network path.</br></br>\n        * This plan allows for use by multiple students and teachers in educational environments.')]]), _ramda2.default.nthArg(1))], [_ramda2.default.equals('seats'), _ramda2.default.compose(getPriceString, _ramda2.default.nthArg(1))], [_ramda2.default.equals('projectInfo'), _ramda2.default.always('The information you share in this section will be kept confidential and not be made public.')]]);

var labelByKey = _ramda2.default.cond([[_ramda2.default.either(_ramda2.default.equals('resolution'), _ramda2.default.equals('accessResolution')), _ramda2.default.always('Max Resolution')], [_ramda2.default.equals('higherRevenueAlternate'), _ramda2.default.always('Revenue')], [_ramda2.default.equals('license'), _ramda2.default.compose(_ramda2.default.cond([[_ramda2.default.propEq('value', 'freelancer'), _ramda2.default.always('*Single-user')], [_ramda2.default.propEq('value', 'indie'), _ramda2.default.always('*Up to 10 users')], [_ramda2.default.propEq('value', 'studio'), _ramda2.default.always('*Up to 25 users')]]), _ramda2.default.nthArg(1))], [_ramda2.default.T, _ramda2.default.always(undefined)]]);

var getPlaceholderByKey = _ramda2.default.cond([[_ramda2.default.equals('projectName'), _ramda2.default.always('Please enter the name or working title of your project.')], [_ramda2.default.equals('projectDetails'), _ramda2.default.always('Tell us a little about how Megascans will be used in your project.')]]);

var buttonSection = function buttonSection(display) {
  return (0, _glamor.css)({
    display: display && 'none'
  });
};

var choiceSection = (0, _glamor.css)((0, _polyfluid.polyfluid)({
  paddingTop: {
    smallMedium: 2.25,
    large: [2.5, 3]
  },
  paddingBottom: {
    smallMedium: 2.25,
    large: [2.5, 3]
  }
}));

var choices = (0, _glamor.css)((0, _polyfluid.polyfluid)({
  marginBottom: {
    smallMedium: 2,
    large: [1.8, 1.8]
  }
}));

var validate = function validate(values) {
  var errors = {};
  if (values.hasOwnProperty('projectName')) {
    if (!values.projectName || _ramda2.default.isEmpty(values.projectName.trim())) {
      errors.projectName = 'Project name is Required';
    } else if (values.projectName.length > 100) {
      errors.projectName = 'Project name can not exceed 100 characters';
    }
  }
  return errors;
};
var SubscriptionChoices = (_dec = (0, _reduxForm.reduxForm)({ form: 'subscription-choice', validate: validate }), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(SubscriptionChoices, _React$Component);

  function SubscriptionChoices() {
    (0, _classCallCheck3.default)(this, SubscriptionChoices);
    return (0, _possibleConstructorReturn3.default)(this, (SubscriptionChoices.__proto__ || (0, _getPrototypeOf2.default)(SubscriptionChoices)).apply(this, arguments));
  }

  (0, _createClass3.default)(SubscriptionChoices, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var onChange = this.props.onChange;
      var values = nextProps.values;


      if (onChange && !_ramda2.default.equals(this.props.values, values)) {
        onChange(values);
      }

      if (nextProps.isMultiSeat && nextProps.submittedForm && nextProps.submittedForm !== this.props.submittedForm) {
        nextProps.fields.projectName.onBlur();
      }
    }
  }, {
    key: 'renderField',
    value: function renderField(field, key) {
      if (key === 'projectName' || key === 'projectDetails' || key === 'agreement' || key === 'seats') return null;
      var _props = this.props,
          options = _props.options,
          monthlyPoints = _props.monthlyPoints,
          annualPoints = _props.annualPoints,
          annualDiscount = _props.annualDiscount,
          values = _props.values,
          licence = _props.licence,
          type = _props.type;
      var _props$values = this.props.values,
          accessResolution = _props$values.accessResolution,
          billing = _props$values.billing;


      var radioButtons = _ramda2.default.map(_ramda2.default.converge(_ramda2.default.assoc('label'), [_ramda2.default.curryN(2, labelByKey)(key), _ramda2.default.identity]))(options[key]);

      //Remove annual options for personal Zero plan.

      if (type === 'personal-0-app' && licence === 'freelancer') radioButtons = _ramda2.default.reject(function (n) {
        return n.value === 'annual';
      }, radioButtons);

      //////////////////////////////////////////////

      if (key === 'billing') {
        radioButtons = radioButtons.map(function (radioButton) {
          // if (radioButton.value === 'monthly') {
          //   radioButton.label = '$' + (seats ? (seats * monthlyAmount[accessResolution || 2048][0]) : monthlyAmount[accessResolution || 2048][0]) + '/month';
          if (radioButton.value === 'annual') {
            radioButton.label = '20% bonus points'; //'Save $' + annualDiscount[accessResolution];
            //'$' + (seats ? (seats * (annualAmount[accessResolution || 2048][0] / 12)) : (annualAmount[accessResolution || 2048][0] / 12)) + '/month';
          } else if (radioButton.name === 250 || radioButton.name === 500 || radioButton.name === 1000) {
            radioButton.label = 'Points / Year';
          } else radioButton.label = '';

          radioButton.className = (0, _glamor.css)({
            minHeight: 49,
            minWidth: 131
          });
          return radioButton;
        });

        radioButtons = _ramda2.default.reverse(radioButtons);
      } else if (key === 'points') {
        radioButtons = radioButtons.map(function (radioButton) {
          // if (radioButton.value === 'monthly') {
          //   radioButton.label = '$' + (seats ? (seats * monthlyAmount[accessResolution || 2048][0]) : monthlyAmount[accessResolution || 2048][0]) + '/month';
          if (radioButton.name === 250 || radioButton.name === 500 || radioButton.name === 1000) {
            radioButton.label = 'Points / Year';
          } else radioButton.label = '';

          radioButton.className = (0, _glamor.css)({
            minHeight: 49
          });
          return radioButton;
        });
        if (licence !== 'indie') radioButtons = _ramda2.default.reverse(radioButtons);
      } else if (key === 'billingCycle') {
        radioButtons = radioButtons.map(function (radioButton) {
          // if (radioButton.value === 'monthly') {
          //   radioButton.label = '$' + (seats ? (seats * monthlyAmount[accessResolution || 2048][0]) : monthlyAmount[accessResolution || 2048][0]) + '/month';

          radioButton.label = 'Months';

          radioButton.className = (0, _glamor.css)({
            minHeight: 49
          });
          return radioButton;
        });
      } else if (key === 'resolution' || 'accessResolution') {
        radioButtons = radioButtons.map(function (radioButton) {
          if (radioButton.value === 4096 && licence === 'freelancer') {
            if (values.billing === 'annual') {
              radioButton.points = annualPoints[radioButton.value] + '';
              radioButton.points = monthlyPoints[radioButton.value] + '';
              radioButton.pointsLable = 'Points / Month';
            } else {
              radioButton.points = monthlyPoints[radioButton.value] + '';
              radioButton.pointsLable = 'Points / Month';
            }
          } else if (radioButton.value === 4097 && licence === 'freelancer') {
            if (values.billing === 'annual') {
              radioButton.points = annualPoints[radioButton.value] + '';
              radioButton.pointsLable = 'Points / Year';
            } else {
              radioButton.points = monthlyPoints[radioButton.value] + '';
              radioButton.pointsLable = 'Points / Month';
            }
          } else if (radioButton.value === 8192 && licence === 'freelancer') {
            if (values.billing === 'annual') {
              radioButton.points = annualPoints[radioButton.value] + '';
              radioButton.pointsLable = 'Points / Year';
            } else {
              radioButton.points = monthlyPoints[radioButton.value] + '';
              radioButton.pointsLable = 'Points / Month';
            }
          }

          if (radioButton.value === 8192 && licence === 'archviz') {
            radioButton.points = annualPoints[radioButton.value] + '';
            radioButton.pointsLable = 'Points / Year';
          } else if (radioButton.value === 8193 && licence === 'archviz') {
            radioButton.points = annualPoints[radioButton.value] + '';
            radioButton.pointsLable = 'Points / Year';
          } else if (radioButton.value === 4096 && licence === 'archviz') {
            radioButton.points = annualPoints[radioButton.value] + '';
            radioButton.pointsLable = 'Points / Year';
          }

          return radioButton;
        });
      }
      var footer = footnoteByKey(key, licence, this.props.selectedPlan.points);

      if (type === 'personal-0-app' && licence === 'freelancer') footer = null;

      var title = titleByKey(key, key === 'resolution' || 'accessResolution' ? licence === 'indie' ? '' : billing === 'monthly' ? '& Points / Month' : ' & Points / Year' : 'months', licence);

      if (key === 'billing' && licence === 'freelancer' && type.indexOf('personal-8K') > -1) {
        footer = footer + '<br>* 8K is available for most 3D assets and all surfaces in 2x2 meters and above.';
      }

      var normalNote = null;

      // if(key==='billing' && licence === 'freelancer' && type.indexOf('personal-0-app')===-1 && type.indexOf('personal-8K')>-1){
      // } else if((key==='billing' && licence === 'freelancer' && type.indexOf('personal-0-app')===-1 && type.indexOf('personal-4K')>-1)){
      //   normalNote='Annual subscribers get a 35% discount and the entire year’s points up front.'
      // }

      normalNote = 'Annual subscribers get 20% extra points and the entire year’s points upfront.';

      return _react2.default.createElement(
        'div',
        { className: buttonSection(type.indexOf('personal') > -1 && radioButtons[0].label.indexOf('Max Resolution') > -1), key: title },
        _react2.default.createElement(
          'div',
          { className: choiceSection },
          _react2.default.createElement(_ChoiceSection2.default, {
            title: title,
            footnote: footer,
            normalNote: normalNote,
            choiceRadioGroup: (0, _extends3.default)({
              radioButtons: radioButtons,
              useSmallRadioButton: key === 'seats'
            }, field)
          })
        ),
        _react2.default.createElement(_Hr2.default, null)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          fields = _props2.fields,
          isMultiSeat = _props2.isMultiSeat,
          agreement = _props2.agreement,
          licence = _props2.licence,
          selectedPlan = _props2.selectedPlan;

      var footer = footnoteByKey('license', licence, selectedPlan && selectedPlan.points);

      return _react2.default.createElement(
        'section',
        null,
        _react2.default.createElement(
          'div',
          { className: choices },
          _ramda2.default.values(_ramda2.default.mapObjIndexed(this.renderField.bind(this), fields)),
          isMultiSeat && _react2.default.createElement(
            'div',
            { key: 'Project Info' },
            _react2.default.createElement(
              'div',
              { className: choiceSection },
              _react2.default.createElement(_ChoiceDetails2.default, {
                title: 'Project Info',
                name: (0, _extends3.default)({}, fields.projectName, {
                  placeholder: getPlaceholderByKey('projectName'),
                  label: 'Project Name'
                }),
                details: (0, _extends3.default)({}, fields.projectDetails, {
                  placeholder: getPlaceholderByKey('projectDetails'),
                  label: 'Project Details (Optional)'
                }),
                footnote: footnoteByKey('projectInfo')
              })
            ),
            _react2.default.createElement(_Hr2.default, null)
          ),
          _react2.default.createElement(_ChoiceLicence2.default, {
            checkbox: (0, _extends3.default)({}, agreement, { label: 'I agree to this.' }),
            title: titleByKey('license'),
            footnote: footer
          })
        )
      );
    }
  }]);
  return SubscriptionChoices;
}(_react2.default.Component)) || _class);
exports.default = SubscriptionChoices;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SubscriptionChoices/SubscriptionChoices.jsx
// module id = 2490
// module chunks = 0